import React, { useEffect } from 'react';
import { Switch } from 'react-router-dom';
import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { roles } from 'utility/constants/roles';
import { withRouter } from 'react-router';
import useMethodicSession from 'components/ChatGate/useMethodicSession';
import openMethodicChat from 'components/ChatGate/openMethodicChat';
import startChatProgrammatically from 'utility/chat/startChatProgrammatically';

const ChatRouter = ({ history }) => {
	const { moduleUrl, isUsable } = useMethodicSession();

	// Opens chat and redirects to home. `isUsable`, not just configured,
	// since `openMethodicChat` only works on an already-initialized widget.
	useEffect(() => {
		if (isUsable) {
			openMethodicChat(moduleUrl).catch((error) => {
				// eslint-disable-next-line no-console
				console.error(
					new Error('Failed to open Methodic chat', { cause: error }),
				);
				startChatProgrammatically();
			});
		} else {
			startChatProgrammatically();
		}
		history.push('/');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
				path="/chat/"
				component={() => <div />}
			/>
		</Switch>
	);
};

export default withRouter(ChatRouter);
